const getCorrectPluralization = (value: number, prefix: string) => {
  if (value === 1) {
    return `${value} question ${prefix}`;
  }

  return `${value} questions ${prefix}`;
};

export default getCorrectPluralization;
